// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFileJpgOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 20a1 1 0 0 0 1-1v-9h-5a1 1 0 0 1-1-1V4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1zm.672-12L14 4.328V8zm-4-6a2 2 0 0 1 1.414.586l4.328 4.328A2 2 0 0 1 20 8.328V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zm1.38 11.491H17c-.01.556-.06.861-.2 1.162-.31.686-.927 1.067-1.738 1.067-1.192 0-2.013-.817-2.013-2.004 0-1.206.831-2.023 2.048-2.023.806 0 1.342.336 1.698 1.062l-.932.386c-.17-.411-.43-.601-.811-.601-.56 0-.976.506-.976 1.182 0 .345.125.69.34.916.16.18.386.275.666.275.27 0 .496-.1.641-.28.07-.1.105-.19.135-.38h-.806zM8.923 15.29a1.25 1.25 0 0 1-.936.396c-.421 0-.737-.18-.987-.561l.641-.646c.025.22.15.365.315.365.14 0 .23-.085.26-.235l.01-.067c.006-.059.006-.118.006-.349V11.81h.981v2.609c0 .425-.07.63-.29.871zm.978.295V11.81h1.557c.441 0 .701.085.947.32.24.23.365.536.365.932 0 .375-.105.696-.305.916-.21.24-.52.35-.972.35h-.61v1.257zm1.843-2.514c0-.315-.175-.475-.536-.475h-.326v.946h.321c.376 0 .54-.145.54-.47z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFileJpgOutline;
